module.exports = __webpack_public_path__ + "img/br41.3d56bf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br41.jpg
// module id = AvZV
// module chunks = 0